import { getImageBasePath } from 'utils/generics';

export const GENERIC_PARTNER_LOGO_PATH = '/icons/partner-icon-with-label.svg';

export function getStaticPartnerLogoFallbackPath(partnerId?: string): string {
    switch ((partnerId || '').toLowerCase()) {
        case 'oppo':
            return '/logos/oppo.png';
        case 'ather':
            return '/logos/ather.svg';
        default:
            return GENERIC_PARTNER_LOGO_PATH;
    }
}

/**
 * CloudFront signatures use `~`. Some API/log serializers emit the literal
 * characters `\x7e` (or `\\x7e`), which CloudFront rejects as MalformedSignature.
 */
export function sanitizePartnerLogoUrl(url: string): string {
    if (!url || typeof url !== 'string') return '';
    return url
        .trim()
        .replace(/\\\\x7e/gi, '~')
        .replace(/\\x7e/gi, '~');
}

/** Prefer sanitized remote logo; otherwise partner-specific / generic static asset. */
export function resolvePartnerLogoSrc(
    logo?: string | null,
    partnerId?: string
): string {
    const sanitized = sanitizePartnerLogoUrl(logo || '');
    if (sanitized) return sanitized;
    return getImageBasePath(getStaticPartnerLogoFallbackPath(partnerId));
}

/**
 * img onError chain: remote → partner static → generic → hide.
 * Uses data-logo-fallback-stage to avoid infinite loops.
 */
export function onPartnerLogoImgError(
    event: { currentTarget: HTMLImageElement },
    partnerId?: string
) {
    const img = event.currentTarget;
    const stage = img.dataset.logoFallbackStage || 'remote';

    if (stage === 'remote' || stage === 'initial') {
        img.dataset.logoFallbackStage = 'static';
        img.src = getImageBasePath(getStaticPartnerLogoFallbackPath(partnerId));
        return;
    }

    if (stage === 'static') {
        const generic = getImageBasePath(GENERIC_PARTNER_LOGO_PATH);
        if (img.src.includes('partner-icon-with-label')) {
            img.style.visibility = 'hidden';
            return;
        }
        img.dataset.logoFallbackStage = 'generic';
        img.src = generic;
        return;
    }

    img.style.visibility = 'hidden';
}
